import { FormattedMessage } from 'react-intl';

import { Link } from '@/components/Header/components/HeaderInfo/HeaderInfo.styles';
import { getBrandConfig } from '@/lib/configuration/configuration';

export const CatalogDownloadTitle = (
  <FormattedMessage
    defaultMessage='Download The Catalog'
    id='catalogDownload.catalogDownloadTitle'
  />
);

export const CatalogDownloadDesc = (
  <FormattedMessage
    defaultMessage='Fill out this form to download Breitling’s Chronolog'
    id='catalogDownload.catalogDownloadDesc'
  />
);

export const CatalogDownloadKeepInformed = (
  <FormattedMessage
    defaultMessage='I would like to be kept informed by Breitling SA including my preferred Boutique about offers and events related to Breitling products by email, telephone and SMS, post and WhatsApp. You can revoke this consent at any time by sending a message to {dataPrivacyEmail} or by clicking the “unsubscribe” button in our marketing emails.'
    id='catalogDownload.CatalogDownloadKeepInformed'
    values={{
      dataPrivacyEmail: (
        <Link
          href={`mailto: ${getBrandConfig().dataPrivacyEmail}`}
          rel='noreferrer'
          target='_blank'
        >
          {getBrandConfig().dataPrivacyEmail}
        </Link>
      ),
    }}
  />
);

export const CatalogDownloadSuccessDescGuest = (
  <FormattedMessage
    defaultMessage='We have sent an email to the address you entered during registration. Click on the link to confirm your email address. It may take a few minutes to receive a confirmation email. If you do not receive a confirmation email, be sure to check your spam folder.'
    id='catalogDownload.CatalogDownloadSuccessDescGuest'
  />
);

export const CatalogDownloadSuccessDescUser = (
  <FormattedMessage
    defaultMessage='Thank you for downloading the Chronolog.'
    id='catalogDownload.CatalogDownloadSuccessDescUser'
  />
);

export const ChronologDownloadButton = (
  <FormattedMessage
    defaultMessage='Chronolog Download'
    id='CatalogDownload.ChronologDownloadButton'
  />
);

export const DownloadVerifyError = (
  <FormattedMessage
    defaultMessage='Chronolog Download Error'
    id='CatalogDownload.DownloadVerifyError'
  />
);
